module.exports = __webpack_public_path__ + "media/images/massage-67d81d9bb4783659e0c8645662c9f717.jpg";